<template>
  <modal 
    name="mfa-notice-modal" 
    :pivotY="0.2"
    height="auto"
    :width="'540px'"
    :adaptive="true"
    :scrollable="true"
    @before-open="beforeOpen"
    @opened="opened">
    
    <div class="bg-white relative">
      <div class="flex justify-center">
        <img src="https://blush-design.imgix.net/collections/shiny-happy-people/banner-0.png?auto=compress&cs=srgb" class="" style="height:280px" />
      </div>

      <a href="#" @click.prevent="close">
        <svg width="20" height="20" stroke-width="2" class="text-gray-700 absolute" style="top:10px;right:10px;" stroke="currentColor" fill="none">
          <use xlink:href="/img/feather-sprite.svg#x-circle"/>
        </svg>
      </a>

      <div class="p-6">
        <div class="text-lg font-light text-gray-700">
          Enable Multi-Factor Authentication for improved security.
        </div>

        <div class="mt-2 text-base text-gray-800">
          You can now enable <span class="font-semibold">Multi-Factor Authentication</span> to improve your
          {{ getAppName }} account and data. 
        </div>

        <div class="mt-4 text-base text-gray-800">
          Using your mobile phone as a secondary device, you will receive a digital code 
          when you login to ensure that your account &amp; data is secure.
        </div>

        <!--<div class="mt-2 text-base text-gray-800" v-if="reason == 'auto-post'">
          Hey there. Hope you're enjoying {{ getAppName }}. You're currently on the <span class="font-semibold">Free Plan</span>, which
          does not include any content integrations. To integrate with these services, please upgrade to a paid plan,
          which starts at $3 per month.
        </div>

        <div class="mt-2 text-base text-gray-800" v-if="reason == 'submit-content'">
          Hey there. Hope you're enjoying {{ getAppName }}. You're currently on the <span class="font-semibold">Free Plan</span>, which
          does not include a feature to submit a content. To integrate with these services, please upgrade to a paid plan,
          which starts at $3 per month.
        </div> -->

        <div class="button-line">
          <SubmitButton :onClick="upgrade" :loading="loading" label="Let's Enable It!" :isFullWidth="true" />
        </div>

        <div class="mt-4 text-center">
          <a href="#" @click.prevent="ignoreThis" class="text-sm text-gray-600 hover:underline">Don't show this message for a week</a>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
  import { EventBus }   from '@/shared/event-bus'
  import SubmitButton   from '@/shared/components/form/SubmitButton'

  export default {

    components : {
      SubmitButton
    },

    data() {
      return {
        reason : null,
        loading: false
      }
    },

    methods : {
      
      beforeOpen(event) {
        this.loading = false
        // this.reason  = event.params.reason
      },

      opened(event) {
        // this.$refs.message.focus()
      },

      close() {
        this.$modal.hide('mfa-notice-modal')
      },

      upgrade() {
        this.$router.push({
          name : 'broker-multi-factor-auth',
          params : {
            brokerId : this.$store.state[this.$store.state.view + 'Module'].broker.id
          }
        })
      },

      ignoreThis() {
        this.$cookies.set('ignore-mfa-modal', '1', 60 * 60 * 24 * 7)
        this.close()
      }
    }
  }
</script>